import { render, staticRenderFns } from "./category-table.vue?vue&type=template&id=5191d60e"
import script from "./category-table.vue?vue&type=script&lang=js"
export * from "./category-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports